const ru = {
  brand: "E2 Care",
  tagline: "Спокойный, связанный уход.",
  nav_dashboard: "Панель",
  nav_residents: "Пациенты",
  nav_patients: "Пациенты",
  nav_rooms: "Комнаты",
  nav_devices: "Устройства",
  nav_events: "События",
  nav_alerts: "Оповещения",
  nav_users: "Команда",
  nav_settings: "Настройки",
  nav_admin: "Администрирование",
  nav_signout: "Выйти",
  topbar_search_placeholder: "Поиск пациентов, комнат, устройств…",
  admin_super_only: "Только суперадминистраторы могут управлять организациями.",
  admin_admin_only: "Только администраторы имеют доступ к этой странице.",
  admin_tab_orgs: "Организации",
  admin_tab_users: "Пользователи",
  admin_tab_patients: "Пациенты",
  admin_tab_rooms: "Комнаты",
  admin_tab_buildings: "Здания",
  admin_tab_devices: "Устройства",
  admin_tab_alerts: "Оповещения",
  admin_tab_qa: "Тестовые инструменты",
  admin_delete: "Удалить",
  admin_no_orgs_yet: "Пока нет организаций.",
  admin_field_name: "Имя",
  admin_field_email: "Эл. почта",
  admin_field_phone: "Телефон",
  admin_field_password: "Пароль",
  admin_field_role: "Роль",
  admin_field_type: "Тип",
  admin_field_timezone: "Часовой пояс",
  admin_field_address: "Адрес",
  admin_field_status: "Статус",
  admin_field_organization: "Организация",
  admin_password_keep: "Оставьте пустым, чтобы сохранить текущий",
  admin_field_birth_date: "Дата рождения",
  admin_field_room: "Комната",
  admin_field_room_none: "Не назначено",
  admin_field_photo: "URL фото",
  admin_field_photo_hint: "Вставьте публичный URL изображения — полная загрузка в версии 2.",
  admin_field_notes: "Заметки ухаживающего",
  admin_field_emergency_contact: "Основной экстренный контакт",
  admin_field_ec_name: "Имя",
  admin_field_ec_phone: "Телефон",
  admin_field_ec_relationship: "Родство",
  admin_field_mac: "MAC-адрес",
  admin_field_firmware: "Прошивка",
  admin_field_assignment: "Назначено",
  admin_field_assigned_room: "Назначенная комната",
  admin_field_assigned_patient: "Назначенный пациент",
  admin_field_assigned_hint: "Необязательно. Датчики обычно привязывают к комнате, браслеты — к пациенту.",
  admin_field_sensor_target: "Установлен на",
  admin_field_sensor_target_hint: "Сообщает системе, следит ли этот датчик за дверью или окном.",
  sensor_target_door: "Дверь",
  sensor_target_window: "Окно",
  sensor_target_unset: "Не настроено",
  admin_field_sensor_label: "Метка датчика",
  admin_field_sensor_label_hint: "Удобное имя, отображаемое в оповещениях и событиях — напр. «Входная дверь», «Окно ванной».",
  admin_field_building: "Здание",
  admin_field_building_required: "Комната должна принадлежать зданию.",
  room_openings: "Проёмы",
  room_no_openings: "В этой комнате пока не установлены датчики дверей или окон.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Последнее изменение",
  admin_field_description: "Описание",
  admin_field_severity: "Важность",
  admin_field_patient: "Пациент",
  admin_field_device: "Устройство",
  admin_field_message: "Сообщение",
  admin_orgs_title: "Организации",
  admin_orgs_sub: "Создавайте, редактируйте и архивируйте арендаторов E2 Care.",
  admin_orgs_count: "организации",
  admin_org_new: "Новая организация",
  admin_org_new_title: "Новая организация",
  admin_org_edit_title: "Редактировать организацию",
  admin_org_created: "Организация создана.",
  admin_org_updated: "Организация обновлена.",
  admin_org_deleted: "Организация заархивирована.",
  admin_org_delete_title: "Заархивировать организацию?",
  admin_org_delete_confirm: "Это скроет «{name}» из списков. При необходимости её можно восстановить из базы данных.",
  admin_users_title: "Пользователи",
  admin_users_sub_super: "Управляйте всеми учётными записями пользователей у всех арендаторов.",
  admin_users_sub_org: "Управляйте учётными записями пользователей для {org}.",
  admin_user_new: "Новый пользователь",
  admin_user_new_title: "Новый пользователь",
  admin_user_edit_title: "Редактировать пользователя",
  admin_user_created: "Пользователь создан.",
  admin_user_updated: "Пользователь обновлён.",
  admin_user_deleted: "Пользователь заархивирован.",
  admin_user_delete_title: "Заархивировать пользователя?",
  admin_user_delete_confirm: "«{name}» потеряет доступ. Активные сеансы не завершаются.",
  admin_user_memberships: "Членство в организациях",
  admin_patients_title: "Пациенты",
  admin_patients_sub_super: "Управляйте всеми карточками пациентов у всех арендаторов.",
  admin_patients_sub_org: "Управляйте карточками пациентов в {org}.",
  admin_patient_new: "Новый пациент",
  admin_patient_new_title: "Новый пациент",
  admin_patient_edit_title: "Редактировать пациента",
  admin_patient_created: "Пациент создан.",
  admin_patient_updated: "Пациент обновлён.",
  admin_patient_deleted: "Пациент заархивирован.",
  admin_patient_delete_title: "Заархивировать пациента?",
  admin_patient_delete_confirm: "«{name}» будет скрыт из списков. Связи с командой ухода и семьёй сохранены.",
  admin_rooms_title: "Комнаты",
  admin_rooms_sub_super: "Настраивайте комнаты у всех арендаторов.",
  admin_rooms_sub_org: "Настраивайте комнаты в {org}.",
  admin_room_new: "Новая комната",
  admin_room_new_title: "Новая комната",
  admin_room_edit_title: "Редактировать комнату",
  admin_room_created: "Комната создана.",
  admin_room_updated: "Комната обновлена.",
  admin_room_deleted: "Комната заархивирована.",
  admin_room_delete_title: "Заархивировать комнату?",
  admin_room_delete_confirm: "«{name}» будет скрыта. Существующие пациенты сохраняют ссылку assigned_room_id.",
  admin_devices_title: "Устройства",
  admin_devices_sub_super: "Подготавливайте устройства Moko у всех арендаторов.",
  admin_devices_sub_org: "Подготавливайте устройства Moko в {org}.",
  admin_device_new: "Новое устройство",
  admin_device_new_title: "Новое устройство",
  admin_device_edit_title: "Редактировать устройство",
  admin_device_created: "Устройство создано.",
  admin_device_updated: "Устройство обновлено.",
  admin_device_deleted: "Устройство заархивировано.",
  admin_device_delete_title: "Заархивировать устройство?",
  admin_device_delete_confirm: "Устройство {mac} будет скрыто. Прошлые события и оповещения остаются в истории.",
  admin_buildings_title: "Здания",
  admin_buildings_sub_super: "Группируйте комнаты по физическому зданию / крылу у всех арендаторов.",
  admin_buildings_sub_org: "Группируйте комнаты по физическому зданию / крылу в {org}.",
  admin_building_new: "Новое здание",
  admin_building_new_title: "Новое здание",
  admin_building_edit_title: "Редактировать здание",
  admin_building_created: "Здание создано.",
  admin_building_updated: "Здание обновлено.",
  admin_building_deleted: "Здание заархивировано.",
  admin_building_delete_title: "Заархивировать здание?",
  admin_building_delete_confirm: "«{name}» будет скрыто. Комнаты сохраняют ссылку corpus_id.",
  admin_qa_title: "Тестовые инструменты",
  admin_qa_sub: "Внедряйте события / оповещения, чтобы протестировать панель, рассылку оповещений и каналы уведомлений без использования реальных устройств Moko.",
  admin_qa_event_title: "Внедрить тестовое событие",
  admin_qa_event_sub: "Имитирует вебхук устройства Moko. Бэкенд запустит свой конвейер рассылки оповещений, как если бы событие пришло с реального оборудования.",
  admin_qa_alert_title: "Внедрить тестовое оповещение",
  admin_qa_alert_sub: "Пропускает слой событий и записывает оповещение напрямую. Используйте для проверки колокольчика, списка и рассылки Slack/Telegram.",
  admin_qa_inject_event: "Внедрить событие",
  admin_qa_inject_alert: "Внедрить оповещение",
  admin_qa_event_done: "Событие внедрено. Следите за страницей События и панелью.",
  admin_qa_alert_done: "Оповещение внедрено. Следите за колокольчиком.",
  admin_qa_disclaimer: "Эти конечные точки следует отключить или пометить флагом в продакшене.",
  admin_alerts_title: "Политика оповещений",
  admin_alerts_sub: "Правила оповещений для всей {org}. Применяются к каждому пациенту этого арендатора.",
  admin_alerts_quiet_title: "Тихие часы",
  admin_alerts_quiet_desc: "Определите, когда эта организация находится в «ночном режиме». Полезно для более тихой маршрутизации некритичных оповещений.",
  admin_alerts_quiet_hint: "Время интерпретируется в локальном часовом поясе организации. Диапазон может переходить через полночь (напр. 22:00 → 06:00).",
  admin_alerts_night_start: "Ночь начинается",
  admin_alerts_night_end: "Ночь заканчивается",
  admin_alerts_load_failed: "Загрузить политику оповещений",
  admin_alerts_save_failed: "Сохранить политику оповещений",
  admin_alerts_saved: "Политика оповещений сохранена.",
  admin_alerts_clear_title: "Очистить активные оповещения",
  admin_alerts_clear_desc: "Подтвердите все открытые оповещения этой организации одним кликом.",
  admin_alerts_clear_hint: "Полезно после запланированных учений или неправильно настроенного датчика, вызвавшего волну ложных срабатываний. Подтверждённые оповещения остаются в истории.",
  admin_alerts_ack_all_button: "Подтвердить все",
  admin_alerts_ack_all_title: "Подтвердить все активные оповещения?",
  admin_alerts_ack_all_confirm: "Это отметит как подтверждённое каждое открытое оповещение в {org}. Это действие нельзя отменить.",
  admin_alerts_ack_all_done: "Подтверждено {count} оповещений.",
  admin_alerts_ack_all_done_generic: "Все активные оповещения подтверждены.",
  admin_alerts_ack_all_failed: "Подтвердить все оповещения",
  org_type_nursing_home: "Дом престарелых",
  org_type_assisted_living: "Жильё с поддержкой",
  org_type_hospital: "Больница",
  org_type_home_care: "Уход на дому",
  role_admin: "Администратор",
  role_caregiver: "Ухаживающий",
  role_family: "Семья",
  status_active: "активен",
  status_inactive: "неактивен",
  confirm: "Подтвердить",
  sign_in: "Войти",
  sign_up: "Зарегистрироваться",
  email: "Эл. почта",
  password: "Пароль",
  full_name: "Полное имя",
  create_account: "Создать учётную запись",
  no_account: "Ещё нет учётной записи?",
  have_account: "Уже есть учётная запись?",
  login_welcome: "С возвращением",
  login_sub: "Войдите, чтобы продолжить наблюдение за вашими подопечными.",
  register_welcome: "Присоединяйтесь к E2 Care",
  register_sub: "Создайте своё рабочее пространство ухаживающего менее чем за минуту.",
  total_residents: "Пациенты",
  active_devices: "Активные устройства",
  open_alerts: "Открытые оповещения",
  offline_gateways: "Устройства офлайн",
  falls_7d: "Падения (7 дн)",
  sos_7d: "SOS (7 дн)",
  low_battery: "Низкий заряд",
  critical_residents: "Критические",
  status_ok: "Всё в порядке",
  status_warning: "Внимание",
  status_critical: "Критический",
  status_online: "В сети",
  status_offline: "Не в сети",
  search: "Поиск",
  filter: "Фильтр",
  all: "Все",
  refresh: "Обновить",
  loading: "Загрузка…",
  no_results: "Здесь пока ничего нет.",
  view_profile: "Просмотреть профиль",
  showing_n_of_m: "Показано {n} из {m}",
  load_more: "Загрузить ещё",
  auto_refresh: "В реальном времени · автообновление",
  auto_refresh_paused: "Приостановлено (активна загрузка ещё)",
  updated_just_now: "Обновлено только что",
  updated_n_sec_ago: "Обновлено {n} с назад",
  updated_n_min_ago: "Обновлено {n} мин назад",
  acknowledge: "Подтвердить",
  acknowledged: "Подтверждено",
  ack_all: "Подтвердить все",
  ack_all_confirm: "Подтвердить все {count} активные оповещения?",
  ack_all_running: "Подтверждение…",
  ack_all_done: "Подтверждено {count} оповещений.",
  ack_all_partial: "{ok} подтверждено · {fail} не удалось.",
  last_seen: "Был(а) в сети",
  battery: "Батарея",
  signal: "Сигнал",
  firmware: "Прошивка",
  room: "Кв. / Комната",
  age: "Возраст",
  emergency_contact: "Экстренный контакт",
  notes: "Заметки",
  assigned_devices: "Назначенные устройства",
  recent_events: "Последние события",
  timeline_24h: "Последние 24 часа",
  delivery_status: "Статус доставки",
  acknowledged_by: "Подтверждено",
  dashboard_title: "Обзор дома",
  dashboard_sub: "Быстрый обзор всего, что происходит в домах, за которыми вы ухаживаете.",
  residents_title: "Пациенты",
  residents_sub: "Люди, за которыми вы сейчас наблюдаете.",
  devices_title: "Устройства",
  devices_sub: "Датчики и метки.",
  devices_sub_admin: "Шлюзы, датчики и метки.",
  events_title: "События в реальном времени",
  events_sub: "Хронологическая лента с каждого подключённого устройства.",
  alerts_title: "Оповещения",
  alerts_sub: "Уведомления, эскалированные семье и ухаживающим.",
  settings_title: "Настройки",
  settings_sub: "Ваши предпочтения и правила уведомлений.",
  users_title: "Команда",
  users_sub: "Ухаживающие, семья и администраторы с доступом.",
  falls_chart_title: "Падения и SOS — последние 7 дней",
  recent_alerts_title: "Последние критические оповещения",
  no_alerts: "Нет открытых оповещений. Все в безопасности.",
  event_fall: "Обнаружено падение",
  event_sos: "Нажата кнопка SOS",
  event_door_open: "Дверь открыта",
  event_door_close: "Дверь закрыта",
  event_inactivity: "Продолжительное бездействие",
  event_low_battery: "Низкий заряд",
  event_offline: "Устройство офлайн",
  event_online: "Устройство снова в сети",
  event_heartbeat: "Сигнал активности",
  event_button_press: "Нажата кнопка",
  device_gateway: "Шлюз Bluetooth",
  device_door_sensor: "Датчик двери",
  device_bracelet: "Браслет",
  device_unknown: "Неизвестное устройство",
  language: "Язык",
  notifications: "Уведомления",
  quiet_hours: "Тихие часы",
  escalation: "Политика эскалации",
  just_now: "только что",
  min_ago: "мин назад",
  h_ago: "ч назад",
  d_ago: "дн назад",
  demo_hint: "Демо-аккаунт: admin@e2care.lv / Care2024!",
  open_menu: "Открыть меню",
  close_menu: "Закрыть меню",
  care_team: "Команда ухода",
  family_members: "Семья",
  no_caregivers: "Ухаживающие ещё не назначены.",
  no_family: "Члены семьи ещё не связаны.",
  add_caregiver: "Добавить ухаживающего",
  add_family: "Добавить члена семьи",
  select_user: "Выберите пользователя…",
  cancel: "Отмена",
  add: "Добавить",
  remove: "Удалить",
  save: "Сохранить",
  relationship: "Родство",
  relationship_son: "Сын",
  relationship_daughter: "Дочь",
  relationship_spouse: "Супруг(а)",
  relationship_other: "Другое",
  notify_via: "Уведомлять через",
  call_contact: "Позвонить контакту",
  view_resident: "Открыть профиль",
  address: "Адрес",
  admin_only_section: "Инструменты администратора",
  rooms_title: "Комнаты",
  rooms_sub: "Каждая комната под вашим наблюдением — пациенты, устройства и текущее состояние.",
  room_name: "Комната",
  room_type: "Тип",
  room_type_private_room: "Отдельная комната",
  room_type_shared_room: "Общая комната",
  room_type_apartment: "Квартира",
  room_type_corridor: "Коридор",
  room_type_common_area: "Общая зона",
  room_floor: "Этаж",
  room_state: "Текущее состояние",
  door: "Дверь",
  window: "Окно",
  door_open_state: "Открыто",
  door_closed_state: "Закрыто",
  door_unknown_state: "Неизвестно",
  room_no_devices: "В этой комнате пока нет устройств.",
  room_no_patients: "В эту комнату пока не назначены пациенты.",
  room_patients: "Пациенты в комнате",
  room_devices: "Устройства в комнате",
  room_activity: "Хронология активности",
  rooms_filter_all_types: "Все типы",
  widget_active_alerts: "Активные оповещения",
  widget_active_alerts_sub: "Критические, нерешённые и подтверждённые",
  widget_patients_status: "Статус пациентов",
  widget_devices_health: "Состояние устройств",
  widget_room_activity: "Активность комнат",
  widget_recent_events: "Лента событий в реальном времени",
  widget_connectivity: "Связь",
  metric_critical: "Критические",
  metric_unresolved: "Нерешённые",
  metric_acknowledged_count: "Подтверждённые",
  metric_total: "Всего",
  metric_active: "Активные",
  metric_online: "В сети",
  metric_offline: "Не в сети",
  metric_ota_pending: "OTA в ожидании",
  metric_battery_warn: "Низкий заряд",
  metric_doors_open: "Открытые двери",
  metric_windows_open: "Открытые окна",
  metric_signal_avg: "Ср. сигнал",
  metric_last_comm: "Последняя связь",
  metric_packets: "Пакеты / час",
  view_all: "Показать все",
  status_new: "Новый",
  status_acknowledged: "Подтверждённый",
  status_resolved: "Решённый",
  status_resolved_local: "Решён (локально)",
  resolve: "Решить",
  add_note: "Добавить заметку",
  save_note: "Сохранить заметку",
  resolve_local_badge: "только это устройство",
  resolve_local_hint: "Отмечает оповещение как решённое только в вашем браузере. Сервер и другие члены команды по-прежнему видят его открытым.",
  note_placeholder: "Добавьте контекст для команды…",
  notes_count: "{n} заметок",
  device_detail: "Сведения об устройстве",
  device_diagnostics: "Диагностика",
  device_firmware_history: "История прошивки",
  device_ota_config: "Конфигурация OTA",
  device_ota_status: "Статус OTA",
  device_signal: "Качество сигнала",
  device_mac: "MAC-адрес",
  device_serial: "Серийный номер",
  fall_sensitivity: "Чувствительность обнаружения падения",
  transmission_interval: "Интервал передачи",
  low_battery_threshold: "Порог низкого заряда",
  ota_idle: "Простой",
  ota_pending: "В ожидании",
  ota_deploying: "Развёртывание",
  ota_failed: "Ошибка",
  events_filter_severity: "Важность",
  events_filter_room: "Комната",
  events_filter_patient: "Пациент",
  events_filter_device: "Устройство",
  severity_info: "Инфо",
  severity_warning: "Предупреждение",
  severity_critical: "Критический",
  telegram_title: "Оповещения Telegram",
  telegram_desc: "Получайте оповещения в Telegram для назначенных вам подопечных.",
  telegram_connect: "Подключить Telegram",
  telegram_connected: "Telegram подключён",
  telegram_connected_as: "Подключено к Telegram как {name}",
  telegram_connect_success: "Telegram успешно подключён",
  telegram_connect_error: "Не удалось подключить Telegram. Попробуйте ещё раз.",
  telegram_missing_bot: "Бот Telegram не настроен. Установите REACT_APP_TELEGRAM_BOT в файле env.",
  telegram_disconnect: "Отключить",
  telegram_disconnect_success: "Telegram отключён.",
  telegram_disconnect_error: "Не удалось отключить Telegram. Попробуйте ещё раз.",
  telegram_already_linked: "Этот аккаунт Telegram уже привязан к другому пользователю e2-care.",
  telegram_switch_q: "Использовать другой аккаунт Telegram?",
  telegram_switch_intro: "Telegram запоминает, какой аккаунт вошёл на всех сайтах. Чтобы использовать другой:",
  telegram_switch_step1: "Откройте Telegram Web и выйдите из текущего аккаунта.",
  telegram_switch_step2: "Вернитесь сюда и перезагрузите кнопку ниже, затем войдите другим аккаунтом.",
  telegram_open_web: "Открыть Telegram Web",
  telegram_reload_widget: "Я вышел — перезагрузить кнопку",
  lang_autodetected_toast: "Определён ваш язык как {language}. Вы можете изменить его в Настройках.",
  admin_view_active: "Активные",
  admin_view_archived: "Заархивированные",
  admin_restore: "Восстановить",
  admin_restored: "Восстановлено.",
  admin_hard_delete: "Удалить навсегда",
  admin_hard_delete_title: "Удалить навсегда?",
  admin_hard_delete_confirm: "Это навсегда удалит «{name}» из базы данных. Это действие нельзя отменить.",
  admin_hard_deleted: "Удалено навсегда.",
  admin_no_archived: "Нет заархивированных элементов.",
  language_desc: "Используется для интерфейса приложения и ваших уведомлений Telegram + push.",
  language_saved: "Язык обновлён.",
  language_error: "Не удалось обновить язык. Попробуйте ещё раз.",
  admin_field_language: "Язык",
  edit: "Редактировать",
  generic_error: "Что-то пошло не так. Попробуйте ещё раз.",
  caregiver_added: "Ухаживающий добавлен.",
  caregiver_removed: "Ухаживающий удалён.",
  family_added: "Член семьи добавлен.",
  family_removed: "Член семьи удалён.",
  menu: "Меню",
  dl_companion_app: "Приложение-компаньон",
  dl_hero_title: "E2 Care для Android",
  dl_hero_sub: "Установите приложение-компаньон на телефон с Moko, чтобы ретранслировать оповещения, настраивать устройства и оставаться на связи с командой ухода — даже когда панель закрыта.",
  dl_android_apk: "APK Android",
  dl_version_loading: "загрузка версии…",
  dl_released: "Выпущено {date}",
  dl_download_apk: "Скачать APK",
  dl_unavailable: "Недоступно",
  dl_preparing: "Подготовка…",
  dl_manifest_error: "Не удалось загрузить манифест. Попробуйте обновить — если проблема сохраняется, сервер сборки может переразвёртываться.",
  dl_whats_new: "Что нового",
  dl_installing_title: "Установка на телефон",
  dl_step1: "Нажмите «Скачать APK» выше. Ваш браузер может предупредить, что файлы APK могут навредить устройству — это предупреждение нормально для любого установщика, скачанного вне Play Store.",
  dl_step2: "Откройте скачанный файл. Android попросит разрешить установку из этого браузера в первый раз — включите разрешение и вернитесь.",
  dl_step3: "Нажмите «Установить», затем «Открыть» по завершении.",
  dl_step4: "Войдите, используя свои учётные данные E2 Care.",
  dl_iphone_note: "Версия для iPhone появится позже. Пока используйте веб-панель.",
  dl_back_to_dashboard: "Назад к панели",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Смена организации очищает текущее назначение комнаты и пациента.",
  admin_view_full: "Полный список",
  device_filter_assignment: "Назначение",
  device_filter_patient: "Назначено пациенту",
  device_filter_room: "Назначено комнате",
  device_filter_unassigned: "Не назначено",
  admin_all_orgs: "Все организации",
  pagination_prev: "Предыдущая",
  pagination_next: "Следующая",
  pagination_per_page: "На странице",
  pagination_page_of: "Страница {page} из {pages}",
  pagination_total: "Всего {total}",
};
export default ru;
